import Component from '@glimmer/component';

const WIDTHS = {
  full: 225,
  icon: 175,
  square: 48
};

export default class MwLogo extends Component {
  get logoUrl() {
    return `/assets/images/logos/logo-${this.args.type}${this.args.accent ? '-accent' : ''}-${this.args.color}${this.iconType ? `-${this.iconType}` : ''}${this.isPng ? '.png' : '.svg'}`;
  }

  get width() {
    return this.args.width ?? WIDTHS[this.args.type];
  }

  get iconType() {
    if (!this.args.iconType) return null;
    return this.args.iconType;
  }
  get isPng() {
    // possibly there can be a problem with svgs having gradient. In such case we can uncomment this fallback
    return false;
    return this.args.accent || this.args.type === 'square';
  }
}
